import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TGpsrRegParseResponsePayload,
	TGpsrStore,
	TGpsrRegisterRequest,
	TGpsrRegParseRequest,
	TGpsrPlansResponsePayload,
	TGpsrItemsResponsePayload,
	TGpsrItemsRequest,
	IGpsrProductTypesRequest,
	TGpsrProductTypesResponsePayload,
	TGenerateGpsrInvoiceRequest,
	TGpsrRegulationsRequest,
	TGpsrRegulationsResponsePayload,
	TAddGpsrProductTypeRequest,
	TAddGpsrRegulationsRequest,
	TDeleteGpsrProductTypeRequest,
	TDeleteGpsrRegulationsRequest,
	TGpsrEditCustomerRequest,
	TGetProductTypeReferencesRequest,
	TGetProductTypeReferencesResponsePayload,
	TGetProductTypeRegulationsGroupTypesRequest,
	TGetProductTypeRegulationsGroupTypesResponsePayload,
	TGetProductTypeRegulationsReferencesRequest,
	TGetProductTypeRegulationsReferencesResponsePayload,
	TGetRegulationsReferencesRequest,
	TGetRegulationsReferencesResponsePayload,
	TGetTechFileRequest,
	TGetTechFileResponsePayload,
	TGetDocFileRequest,
	TGetDocFileResponsePayload,
	TCancelGpsrRequest,
	TActivateGpsrRequest,
	TDownloadGpsrInvoiceRequest,
	TGetInvoicesListResponsePayload,
	TGetInvoicesListRequest,
	TDownloadGpsrLastInvoiceRequest,
	TUpdateGpsrServiceSettingsRequest,
	TUpdateGpsrRemoveOnRenewalRequest,
	TChangeGpsrStatusRequest,
	TGpsrServiceStatusesResponsePayload,
	TGpsrReferralRequest,
} from './types';
// ==========================================:
export const initialState: TGpsrStore = {
	regParser: null,
	regParserLoading: false,
	regParserError: '',
	registerLoading: false,
	registerError: '',
	gpsrPlans: null,
	gpsrItems: null,
	gpsrItemsLoading: false,
	gpsrProductTypes: null,
	gpsrProductTypesLoading: false,
	generateInvoiceGpsrLoading: false,
	gpsrRegulations: null,
	gpsrRegulationsLoading: false,
	gpsrEditCustomerLoading: false,
	gpsrProductTypeReferences: null,
	gpsrProductTypeReferencesLoading: false,
	gpsrProductTypeRegulationsGroupTypes: null,
	gpsrProductTypeRegulationsGroupTypesLoading: false,
	gpsrProductTypeRegulationsReferences: null,
	gpsrProductTypeRegulationsReferencesLoading: false,
	gpsrRegulationsReferences: null,
	gpsrRegulationsReferencesLoading: false,
	gpsrTechFile: null,
	gpsrTechFileLoading: false,
	gpsrDocFile: null,
	gpsrDocFileLoading: false,
	cancelGpsrLoading: false,
	activateGpsrLoading: false,
	downloadGpsrLastInvoiceLoading: false,
	getInvoicesList: null,
	getInvoicesListLoading: false,
	downloadGpsrInvoice: null,
	downloadGpsrInvoiceLoading: false,
	updateGpsrServiceSettingsLoading: false,
	updateGpsrRemoveOnRenewalLoading: false,
	changeGpsrStatusLoading: false,
	gpsrReferralLoading: false,
	gpsrReferralError: '',
	gpsrServiceStatuses: null,
	gpsrServiceStatusesLoading: false,
};

// ==========================================:
const gpsr = createSlice({
	name: '@@gpsr',
	initialState,
	reducers: {
		regParseGpsrRequest: (state: TGpsrStore, action: PayloadAction<TGpsrRegParseRequest>) => {
			const gpsrState = state;
			gpsrState.regParserLoading = true;
			gpsrState.regParser = null;
			gpsrState.regParserError = '';
		},
		regParseGpsrSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrRegParseResponsePayload>,
		) => {
			const { payload } = action;
			const gpsrState = state;
			gpsrState.regParser = payload;
			gpsrState.regParserLoading = false;
			gpsrState.regParserError = '';
		},
		regParseGpsrFailure: (state: TGpsrStore, action: PayloadAction<{ error: string }>) => {
			const { error } = action.payload;
			const gpsrState = state;
			gpsrState.regParserLoading = false;
			gpsrState.regParserError = error;
		},
		registerGpsrRequest: (state: TGpsrStore, action: PayloadAction<TGpsrRegisterRequest>) => {
			const gpsrState = state;
			gpsrState.registerLoading = true;
			gpsrState.registerError = '';
		},
		registerGpsrSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.registerLoading = false;
			gpsrState.registerError = '';
		},
		registerGpsrFailure: (state: TGpsrStore, action: PayloadAction<{ error: string }>) => {
			const { error } = action.payload;
			const gpsrState = state;
			gpsrState.registerLoading = false;
			gpsrState.registerError = error;
		},
		editGpsrCustomerRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrEditCustomerRequest>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrEditCustomerLoading = true;
		},
		editGpsrCustomerSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrEditCustomerLoading = false;
		},

		getGpsrPlansRequest: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrPlans = null;
		},
		getGpsrPlansSuccess: (state: TGpsrStore, action: PayloadAction<TGpsrPlansResponsePayload>) => {
			const { payload } = action;
			const gpsrState = state;
			gpsrState.gpsrPlans = payload;
		},
		getGpsrItemsRequest: (state: TGpsrStore, action: PayloadAction<TGpsrItemsRequest>) => {
			const gpsrState = state;
			// gpsrState.gpsrItems = null;
			gpsrState.gpsrItemsLoading = true;
		},
		getGpsrItemsSuccess: (state: TGpsrStore, action: PayloadAction<TGpsrItemsResponsePayload>) => {
			const { payload } = action;
			const gpsrState = state;
			gpsrState.gpsrItems = payload;
			gpsrState.gpsrItemsLoading = false;
		},
		getGpsrProductTypesRequest: (
			state: TGpsrStore,
			action: PayloadAction<IGpsrProductTypesRequest>,
		) => {
			const gpsrState = state;
			// gpsrState.gpsrProductTypes = null;
			gpsrState.gpsrProductTypesLoading = true;
		},
		getGpsrProductTypesSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrProductTypesResponsePayload>,
		) => {
			const { payload } = action;
			const gpsrState = state;
			gpsrState.gpsrProductTypes = payload;
			gpsrState.gpsrProductTypesLoading = false;
		},
		generateInvoiceGpsrRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGenerateGpsrInvoiceRequest>,
		) => {
			const gpsrState = state;
			gpsrState.generateInvoiceGpsrLoading = true;
		},
		generateInvoiceGpsrSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.generateInvoiceGpsrLoading = false;
		},
		getGpsrRegulationsRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrRegulationsRequest>,
		) => {
			const gpsrState = state;
			// gpsrState.gpsrRegulations = null;
			gpsrState.gpsrRegulationsLoading = true;
		},
		getGpsrRegulationsSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrRegulationsResponsePayload>,
		) => {
			const { payload } = action;
			const gpsrState = state;
			gpsrState.gpsrRegulations = payload;
			gpsrState.gpsrRegulationsLoading = false;
		},
		addGpsrProductTypeRequest: (
			state: TGpsrStore,
			action: PayloadAction<TAddGpsrProductTypeRequest>,
		) => {
			const gpsrState = state;
		},
		deleteGpsrProductTypeRequest: (
			state: TGpsrStore,
			action: PayloadAction<TDeleteGpsrProductTypeRequest>,
		) => {
			const gpsrState = state;
		},
		addGpsrRegulationsRequest: (
			state: TGpsrStore,
			action: PayloadAction<TAddGpsrRegulationsRequest>,
		) => {
			const gpsrState = state;
		},
		deleteGpsrRegulationsRequest: (
			state: TGpsrStore,
			action: PayloadAction<TDeleteGpsrRegulationsRequest>,
		) => {
			const gpsrState = state;
		},
		getProductTypeReferencesRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGetProductTypeReferencesRequest>,
		) => {
			const gpsrState = state;
		},
		getProductTypeReferencesSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGetProductTypeReferencesResponsePayload>,
		) => {
			const gpsrState = state;
			const { payload } = action;
			gpsrState.gpsrProductTypeReferences = payload;
			gpsrState.gpsrProductTypeReferencesLoading = false;
		},
		getProductTypeReferencesFailure: (
			state: TGpsrStore,
			action: PayloadAction<{ error: string }>,
		) => {
			const { error } = action.payload;
			const gpsrState = state;
			gpsrState.gpsrProductTypeReferencesLoading = false;
		},
		getProductTypeRegulationsGroupTypesRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGetProductTypeRegulationsGroupTypesRequest>,
		) => {
			const gpsrState = state;
		},
		getProductTypeRegulationsGroupTypesSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGetProductTypeRegulationsGroupTypesResponsePayload>,
		) => {
			const gpsrState = state;
		},
		getProductTypeRegulationsGroupTypesFailure: (
			state: TGpsrStore,
			action: PayloadAction<{ error: string }>,
		) => {
			const { error } = action.payload;
			const gpsrState = state;
		},
		getProductTypeRegulationsReferencesRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGetProductTypeRegulationsReferencesRequest>,
		) => {
			const gpsrState = state;
		},
		getProductTypeRegulationsReferencesSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGetProductTypeRegulationsReferencesResponsePayload>,
		) => {
			const gpsrState = state;
		},
		getProductTypeRegulationsReferencesFailure: (
			state: TGpsrStore,
			action: PayloadAction<{ error: string }>,
		) => {
			const { error } = action.payload;
			const gpsrState = state;
		},
		getRegulationsReferencesRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGetRegulationsReferencesRequest>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrRegulationsReferencesLoading = true;
		},
		getRegulationsReferencesSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGetRegulationsReferencesResponsePayload>,
		) => {
			const gpsrState = state;
			const { payload } = action;
			gpsrState.gpsrRegulationsReferences = payload;
			gpsrState.gpsrRegulationsReferencesLoading = false;
		},
		getTechFileRequest: (state: TGpsrStore, action: PayloadAction<TGetTechFileRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrTechFileLoading = true;
		},
		getTechFileSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrTechFileLoading = false;
		},
		getDocFileRequest: (state: TGpsrStore, action: PayloadAction<TGetDocFileRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrDocFileLoading = true;
		},
		getDocFileSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrDocFileLoading = false;
		},
		cancelGpsrRequest: (state: TGpsrStore, action: PayloadAction<TCancelGpsrRequest>) => {
			const gpsrState = state;
			gpsrState.cancelGpsrLoading = true;
		},
		cancelGpsrSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.cancelGpsrLoading = false;
		},
		activateGpsrRequest: (state: TGpsrStore, action: PayloadAction<TActivateGpsrRequest>) => {
			const gpsrState = state;
			gpsrState.activateGpsrLoading = true;
		},
		activateGpsrSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.activateGpsrLoading = false;
		},
		downloadGpsrLastInvoiceRequest: (
			state: TGpsrStore,
			action: PayloadAction<TDownloadGpsrLastInvoiceRequest>,
		) => {
			const gpsrState = state;
			gpsrState.downloadGpsrLastInvoiceLoading = true;
		},
		downloadGpsrLastInvoiceSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.downloadGpsrLastInvoiceLoading = false;
		},
		getGpsrInvoicesListRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGetInvoicesListRequest>,
		) => {
			const gpsrState = state;
			gpsrState.getInvoicesListLoading = true;
		},
		getGpsrInvoicesListSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGetInvoicesListResponsePayload>,
		) => {
			const gpsrState = state;
			const { payload } = action;
			gpsrState.getInvoicesList = payload;
			gpsrState.getInvoicesListLoading = false;
		},
		downloadGpsrInvoiceRequest: (
			state: TGpsrStore,
			action: PayloadAction<TDownloadGpsrInvoiceRequest>,
		) => {
			const gpsrState = state;
			gpsrState.downloadGpsrInvoiceLoading = true;
		},
		downloadGpsrInvoiceSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.downloadGpsrInvoiceLoading = false;
		},
		updateGpsrServiceSettingsRequest: (
			state: TGpsrStore,
			action: PayloadAction<TUpdateGpsrServiceSettingsRequest>,
		) => {
			const gpsrState = state;
			gpsrState.updateGpsrServiceSettingsLoading = true;
		},
		updateGpsrServiceSettingsSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.updateGpsrServiceSettingsLoading = false;
		},
		updateGpsrRemoveOnRenewalRequest: (
			state: TGpsrStore,
			action: PayloadAction<TUpdateGpsrRemoveOnRenewalRequest>,
		) => {
			const gpsrState = state;
			gpsrState.updateGpsrRemoveOnRenewalLoading = true;
		},
		updateGpsrRemoveOnRenewalSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.updateGpsrRemoveOnRenewalLoading = false;
		},
		changeGpsrStatusRequest: (
			state: TGpsrStore,
			action: PayloadAction<TChangeGpsrStatusRequest>,
		) => {
			const gpsrState = state;
			gpsrState.changeGpsrStatusLoading = true;
		},
		changeGpsrStatusSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.changeGpsrStatusLoading = false;
		},
		gpsrReferralRequest: (state: TGpsrStore, action: PayloadAction<TGpsrReferralRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrReferralLoading = true;
			gpsrState.gpsrReferralError = '';
		},
		gpsrReferralSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrReferralLoading = false;
			gpsrState.gpsrReferralError = '';
		},
		gpsrReferralFailure: (state: TGpsrStore, action: PayloadAction<{ error: string }>) => {
			const { error } = action.payload;
			const gpsrState = state;
			gpsrState.gpsrReferralLoading = false;
			gpsrState.gpsrReferralError = error;
		},
		getGpsrServiceStatusesRequest: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrServiceStatusesLoading = true;
		},
		getGpsrServiceStatusesSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrServiceStatusesResponsePayload>,
		) => {
			const { payload } = action;
			const gpsrState = state;
			gpsrState.gpsrServiceStatuses = payload;
			gpsrState.gpsrServiceStatusesLoading = false;
		},
		getGpsrServiceStatusesFailure: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrServiceStatusesLoading = false;
		},
		gpsrInitState: () => initialState,
	},
});

export default gpsr.reducer;
export const {
	gpsrInitState,
	regParseGpsrRequest,
	regParseGpsrSuccess,
	regParseGpsrFailure,
	registerGpsrRequest,
	registerGpsrSuccess,
	getGpsrPlansRequest,
	getGpsrPlansSuccess,
	getGpsrItemsRequest,
	getGpsrItemsSuccess,
	getGpsrProductTypesRequest,
	getGpsrProductTypesSuccess,
	generateInvoiceGpsrRequest,
	generateInvoiceGpsrSuccess,
	getGpsrRegulationsRequest,
	getGpsrRegulationsSuccess,
	addGpsrProductTypeRequest,
	deleteGpsrProductTypeRequest,
	addGpsrRegulationsRequest,
	deleteGpsrRegulationsRequest,
	editGpsrCustomerRequest,
	editGpsrCustomerSuccess,
	registerGpsrFailure,
	getProductTypeReferencesRequest,
	getProductTypeReferencesSuccess,
	getProductTypeReferencesFailure,
	getProductTypeRegulationsGroupTypesRequest,
	getProductTypeRegulationsGroupTypesSuccess,
	getProductTypeRegulationsReferencesRequest,
	getProductTypeRegulationsReferencesSuccess,
	getRegulationsReferencesRequest,
	getRegulationsReferencesSuccess,
	getTechFileRequest,
	getTechFileSuccess,
	getDocFileRequest,
	getDocFileSuccess,
	cancelGpsrRequest,
	cancelGpsrSuccess,
	activateGpsrRequest,
	activateGpsrSuccess,
	downloadGpsrLastInvoiceRequest,
	downloadGpsrLastInvoiceSuccess,
	getGpsrInvoicesListRequest,
	getGpsrInvoicesListSuccess,
	downloadGpsrInvoiceRequest,
	downloadGpsrInvoiceSuccess,
	updateGpsrServiceSettingsRequest,
	updateGpsrServiceSettingsSuccess,
	updateGpsrRemoveOnRenewalRequest,
	updateGpsrRemoveOnRenewalSuccess,
	changeGpsrStatusRequest,
	changeGpsrStatusSuccess,
	getGpsrServiceStatusesRequest,
	getGpsrServiceStatusesSuccess,
	getGpsrServiceStatusesFailure,
	gpsrReferralRequest,
	gpsrReferralSuccess,
	gpsrReferralFailure,
} = gpsr.actions;
